/**
 * Storage abstraction. BLUEPRINT section 18.
 *
 * Every store in src/app/stores goes through a StorageAdapter rather than
 * touching localStorage, so a CloudAdapter can replace it later without
 * changing a single store. The interface is async on purpose: a network
 * adapter is the whole point of the indirection.
 *
 * Keys are namespaced by the adapter, so a store asks for "settings" and the
 * adapter reads "gaswars:v1:settings". Values are JSON, serialized by the
 * adapter, so callers deal in plain objects.
 */

export interface StorageAdapter {
  /** Read a value. Resolves to null when the key is absent or unreadable. */
  get<T>(key: string): Promise<T | null>;
  /** Write a value. Resolves once the write is durable for this adapter. */
  set<T>(key: string, value: T): Promise<void>;
  /** Remove one key. Removing an absent key is not an error. */
  remove(key: string): Promise<void>;
  /** Every key this adapter holds, without the namespace prefix, sorted. */
  list(): Promise<string[]>;
}

/** Current storage schema version. Bump when a stored shape changes. */
export const STORAGE_VERSION = 1;

export const STORAGE_NAMESPACE = `gaswars:v${STORAGE_VERSION}`;

export function namespacedKey(namespace: string, key: string): string {
  return `${namespace}:${key}`;
}
